export default __webpack_public_path__ + "static/media/CL-3.da171248.pdf";